<template>
  <div class="course-subject">
    <el-button size="small" type="primary" @click="addSubject" icon="el-icon-plus">添加新科目</el-button>
    <el-form class="form-style" :inline="true" size="small">
      <el-form-item label="类型：">
        <el-select v-model="subject_state" style="width: 200px">
          <el-option label="全部" value=""></el-option>
          <el-option label="平台标准科目" :value="1"></el-option>
          <el-option label="机构自研科目" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="search" type="primary">搜索</el-button>
      </el-form-item>
    </el-form>
    <div class="table-style">
      <el-table size="small" :data="tableData" border :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column align="center" width="120" prop="sort_num" label="排序号"></el-table-column>

        <el-table-column align="center" width="120" prop="code" label="Code"></el-table-column>

        <el-table-column align="center" width="120" prop="name" label="科目"></el-table-column>

        <el-table-column align="center" prop="sort_num" label="类型">
          <template slot-scope="scope">
            {{ scope.row.state === 1 ? "平台标准科目" : "机构自研科目" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="small" v-if="scope.row.state === 1" @click="updateSubject(scope.row)">修改</el-button>

            <el-button size="small" @click="addSystem(scope.row)" v-if="scope.row.state === 1">添加体系</el-button>

            <el-button size="small" type="danger" @click="deleteSubject(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-style">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="page_no"
        layout="total, prev, pager, next" :total="total" :page-size="20"></el-pagination>
    </div>
    <el-dialog title="新增科目" :visible.sync="dialogVisible">
      <el-form class="form-style" ref="form" :model="form" :rules="rules" label-width="100px" size="small"
        label-position="left">
        <el-form-item label="科目名称" required prop="subject_name">
          <el-input placeholder="请输入科目名称" v-model="form.subject_name" style="width: 400px">
          </el-input>
        </el-form-item>
        <el-form-item label="排序号" required prop="sort_num">
          <el-input-number v-model="form.sort_num" :precision="2"></el-input-number>
        </el-form-item>

        <el-form-item label="Code" required prop="sort_num">
          <el-input-number v-model="form.code"></el-input-number>
        </el-form-item>
        <el-form-item label="背景颜色">
          <el-input placeholder="请输入背景颜色" v-model="form.color" style="width: 400px">
          </el-input>
        </el-form-item>
        <el-form-item label="字体颜色">
          <el-input placeholder="请输入背景颜色" v-model="form.font_color" style="width: 400px">
          </el-input>
        </el-form-item>


      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="quitDialog('form')">取 消</el-button>
        <el-button size="small" type="primary" @click="submit('form')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addSubject, updateSubject, deleteSubject } from "@/api/educational.js";
import { getSubjectList } from "@/api/admin.js";
export default {
  name: "course-subject",
  data() {
    return {
      subject_state: 1,
      total: 0,
      page_no: 1,
      subjectId: "",
      form: {
        subject_name: "",
        sort_num: 0,
        code: 0,
        color: '',
        font_color: '',
      },
      tableData: [],
      dialogVisible: false,
      rules: {
        subject_name: [
          {
            required: true,
            message: "请输入标题",
          },
        ],
        sort_num: [
          {
            required: true,
            message: "请输入排序号",
          },
        ],
      },
    };
  },
  mounted() {
    this.getSubjectList();
  },
  methods: {
    search() {
      this.getSubjectList();
    },
    handleCurrentChange(val) {
      this.page_no = val;
      this.getSubjectList();
    },
    addSubject() {
      this.form.subject_name = "";
      this.dialogVisible = true;

      this.form.sort_num = this.total + 1;
      this.form.code = this.total + 1;

    },
    quitDialog(formName) {
      this.subjectId = "";
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    updateSubject(row) {
      this.subjectId = row.id;
      this.form.subject_name = row.name;
      this.form.sort_num = row.sort_num;
      this.form.code = row.code;
      this.form.color = row.color;
      this.form.font_color = row.font_color
      this.dialogVisible = true;
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.subjectId) {
            updateSubject(
              {
                subject_id: this.subjectId,
                subject_name: this.form.subject_name,
                sort_num: this.form.sort_num,
                code: this.form.code,
                color: this.form.color,
                font_color: this.form.font_color
              },
              true
            ).then(() => {
              this.$message.success("修改科目成功！");
              this.dialogVisible = false;
              this.getSubjectList();
            });
          } else {
            addSubject(
              {
                subject_name: this.form.subject_name,
                sort_num: this.form.sort_num,
                subject_state: 1,
                code: this.form.code,
                color: this.form.color,
                font_color: this.form.font_color

              },
              true
            ).then(() => {
              this.$message.success("添加科目成功！");
              this.dialogVisible = false;
              this.getSubjectList();
            });
          }
        }
      });
    },
    deleteSubject(row) {
      this.$confirm("确定删除当前科目?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteSubject(
          {
            subject_id: row.id,
          },
          true
        ).then(() => {
          this.$message.success("删除成功！");
          this.getSubjectList();
        });
      });
    },
    addSystem(row) {
      this.$router.push({
        name: "create-admin-course-system",
        query: {
          id: row.id,
          type: row.state,
        },
      });
    },
    getSubjectList() {
      getSubjectList(
        {
          subject_state: this.subject_state,
          page_no: this.page_no,
          page_size: 20,
        },
        true
      ).then((res) => {
        console.log("平台科目");
        console.log(res);
        this.tableData = res.subject_list;
        this.total = res.total;

      });
    },
  },
};
</script>



<style scoped lang="scss">
.course-subject {
  height: 100%;
  background-color: #fff;
  margin: 15px;
  padding: 15px;

  .form-style {
    margin-left: 15px;
  }

  .table-style {
    margin-top: 15px;
  }
}
</style>
